import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import classNames from "classnames";
import loadable from "@loadable/component";
import { useStyles } from "./styles";
const Lottie = loadable(() => import("lottie-react"));
export const Loader = props => {
  const {
    size,
    thickness,
    className,
    verticallyCenter = false,
    color = "primary",
    variant = "circular",
    value,
    ref,
    loaderLabel,
    ...otherProps
  } = props;
  const classes = useStyles(props);
  const [CPLoader, setCPLoader] = React.useState(null);
  const renderedVariant = value ? "determinate" : "indeterminate";
  useEffect(() => {
    if (variant === "animation") {
      import("./lottie/CPLoader.json").then(data => {
        setCPLoader(data);
        return true;
      }).catch(error => {
        // eslint-disable-next-line no-console
        console.error("Error loading CPLoader.json", error);
      });
    }
  }, [variant]);
  const loader = variant === "linear" ? /*#__PURE__*/React.createElement(LinearProgress, {
    role: "progressbar",
    "aria-label": loaderLabel ?? "Loading...",
    className: classNames("prmbl-loader-inner", classes.inner, className),
    color: color === "inherit" ? undefined : color,
    value: value,
    variant: renderedVariant,
    ref: ref
  }) : variant === "animation" && CPLoader ? /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: /*#__PURE__*/React.createElement(Loader, null)
  }, /*#__PURE__*/React.createElement(Lottie, {
    role: "progressbar",
    "aria-label": loaderLabel ?? "Loading...",
    ref: ref,
    animationData: CPLoader,
    loop: true,
    className: classNames("prmbl-loader-inner", classes.inner, classes.animation, className)
  })) : /*#__PURE__*/React.createElement(CircularProgress, {
    role: "progressbar",
    "aria-label": loaderLabel ?? "Loading...",
    className: classNames("prmbl-loader-inner", classes.inner, className),
    size: size,
    thickness: thickness,
    color: color,
    value: value,
    variant: renderedVariant,
    ref: ref
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames("prmbl-loader", classes.root, {
      [classes.circular]: variant === "circular"
    }, {
      [classes.verticallyCenter]: verticallyCenter
    }),
    "data-testid": "loader"
  }, otherProps), loader);
};
Loader.defaultProps = {
  verticallyCenter: false,
  color: "primary",
  variant: "circular"
};
export default Loader;